import { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { Add } from '@clds/icon';
import { Item, ItemProps } from '@clds/item';
import { getAnalyticsProp } from '@cld/analytics';
import { messages } from '../../../i18n';
import { useCustomerIdContext } from '../../../context';
import { DropdownMenuItemContent } from '../../DropdownMenuItem/DropdownMenuItemContent';

import { NEW_SUB_ACCOUNT_URL } from '../WorkspaceMenu.consts';
import styled from 'styled-components';
import { UpgradePopupModal } from '../../UpgradePopupModal/UpgradePopupModal';
import { useProductEnvModal } from '../../UpgradePopupModal/usePopupModal';
import { useAnalytics } from '@cld/analytics';

const CROWN_ICON = 'https://res.cloudinary.com/prod/image/upload/upgrade-popup-modal/Button.svg';

const IconImage = styled.img<{ size: 'md' | 'sm' }>`
  height: ${({ size, theme }) => theme.font.size[size]};
  width: ${({ size, theme }) => theme.font.size[size]};
  border-radius: ${(props) => props.theme.radius.md};
  vertical-align: center;
`;

const ClearButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  color: #007bff;
  padding: 0;
  width: 100%;

  &:hover {
    text-decoration: none;
  }
`;
interface AddNewWorkspaceProps {
  closeWorkSpaceMenu?: () => void;
  isMobile: boolean;
}

export const AddNewWorkspace: FC<ItemProps & AddNewWorkspaceProps> = ({ children, closeWorkSpaceMenu, isMobile, ...rest }) => {
  const { formatMessage } = useIntl();
  const { currentCustomer } = useCustomerIdContext();
  const customerId = currentCustomer?.externalIdForUrl ?? '';
  const addAccountPath = NEW_SUB_ACCOUNT_URL.replace('{customerId}', customerId);

  const analyticsProps = getAnalyticsProp('intent to add new product environment');

  const [isUpgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const displayProductEnvModal = useProductEnvModal();
  const onCloseUpgradeModal = () => {
    setUpgradeModalOpen(false);
    analytics('add prod env upgrade modal | close using x button', 'close');
  };
  const analytics = useAnalytics('side menu'); // category
  const handleClick = () => {
    analytics('add prod env upgrade modal', 'open modal');
    setUpgradeModalOpen(true);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    closeWorkSpaceMenu && closeWorkSpaceMenu();
  };

  return (
    <>
      {!displayProductEnvModal || isMobile ? (
        <Item {...analyticsProps} {...rest}>
          <a data-test-specifier="add new environment" href={addAccountPath}>
            <DropdownMenuItemContent leftSlot={<Add size="sm" />}>{children ?? formatMessage(messages.workspaceMenuAddNew)}</DropdownMenuItemContent>
          </a>
        </Item>
      ) : (
        displayProductEnvModal &&
        !isMobile && (
          <Item {...analyticsProps} {...rest}>
            <ClearButton type="button" onClick={handleClick}>
              <DropdownMenuItemContent leftSlot={<Add size="sm" />} rightSlot={<IconImage size="sm" src={CROWN_ICON} />}>
                {
                  /* FIXME: children here seems very weird and it looks like they are never present, this needs some investigation */ children
                    ? formatMessage(messages.workspaceMenuAddEnv)
                    : formatMessage(messages.workspaceMenuAddNew)
                }
              </DropdownMenuItemContent>
            </ClearButton>
            <UpgradePopupModal open={isUpgradeModalOpen} onClose={onCloseUpgradeModal} modelPopupKind={'addProductEnvModal'} />
          </Item>
        )
      )}
    </>
  );
};
